import accountIcon from '~/assets/icons/new/account.svg';
import alertTriangleIcon from '~/assets/icons/new/alert.svg';
import cameraIcon from '~/assets/icons/new/camera.svg';
import vehicleIcon from '~/assets/icons/new/carIcon.svg';
import videoRecorderIcon from '~/assets/icons/new/safety-events/event-types/video-recorder.svg';
import userIcon from '~/assets/icons/new/user.svg';
import notificationsIcon from '~/assets/icons/notificationsIcon.svg';
import { AlertEvent } from '~/common/models/alert.model';
import { NotificationType } from '~/common/models/notification.model';

export const iconMap: Record<string | AlertEvent, string> = {
  'app-account-update': accountIcon,
  'low-washer-fluid': vehicleIcon,
  'flat-tire': vehicleIcon,
  'oil-life': vehicleIcon,
  'brake-pads': vehicleIcon,
  'airbag-system': vehicleIcon,
  'antilock-braking-system': vehicleIcon,
  'electric-drive-system': vehicleIcon,
  'emission-system': vehicleIcon,
  'engine-and-transmission': vehicleIcon,
  'lithium-ion-battery': vehicleIcon,
  'low-battery': vehicleIcon,
  'twelve-volt-battery': vehicleIcon,
  'low-brake-fluid': vehicleIcon,
  'low-tire': vehicleIcon,
  'stability-control-system': vehicleIcon,
  'app-add-user': userIcon,
  'app-remove-user': userIcon,
  'app-remove-vehicle': vehicleIcon,
  'onstar-system': vehicleIcon,
  'camera-added': cameraIcon,
  'admin-pin-changed': cameraIcon,
  'lens-obstructed': cameraIcon,
  'safety-event': vehicleIcon,
  'camera-deleted': cameraIcon,
  'camera-not-recording': cameraIcon,
  'camera-offline': cameraIcon,
  'engine-air-filter': vehicleIcon,

  // Batch boarding
  'batch-onboarding': vehicleIcon,
  'batch-offboarding': vehicleIcon,
  'vehicle-onboarding': vehicleIcon,
  'vehicle-offboarding': vehicleIcon,

  // Off-hours driving and vehicle idling
  [AlertEvent.VEHICLE_OFF_HOURS]: vehicleIcon,
  [AlertEvent.VEHICLE_IDLING]: vehicleIcon,

  // Custom video clip request status
  [AlertEvent.VIDEO_CLIP_REQUEST_STATUS]: videoRecorderIcon,

  // EMER events
  [AlertEvent.AUTOMATIC_CRASH_RESPONSE]: alertTriangleIcon,
  [AlertEvent.LOW_LEVEL_COLLISION]: alertTriangleIcon,
  [AlertEvent.THERMAL_EVENT]: vehicleIcon,
  [AlertEvent.THEFT_ALARM]: vehicleIcon,

  // Default icons
  user: userIcon,
  vehicle: vehicleIcon,
  default: notificationsIcon,
};

export const EVENT_NOTIFICATION_MAPPING: {
  [key in AlertEvent]?: NotificationType;
} = {
  [AlertEvent.ADD_USER]: NotificationType.USER_ACTIVITY,
  [AlertEvent.REMOVE_USER]: NotificationType.USER_ACTIVITY,
  [AlertEvent.ACCOUNT_UPDATE]: NotificationType.ACCOUNT_ACTIVITY,
  [AlertEvent.BATCH_ONBOARDING]: NotificationType.VEHICLE,
  [AlertEvent.BATCH_OFFBOARDING]: NotificationType.VEHICLE,
  [AlertEvent.DEPRECATED_OFFBOARDING_VEHICLE]: NotificationType.VEHICLE,
};
